import { useState } from 'react';
import { subDays, format, isValid, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { DateContainer, DateContent, PeriodContent, TextFieldStyled, ToStyled } from './styles';
import { StyledChip } from '../../pages/Dashboard/components/Filter/RetrofitDateModal/styles';

const DEFAULT_PERIODS = [
  { key: 'LAST_7', label: '7 dias', days: 7 },
  { key: 'LAST_15', label: '15 dias', days: 15 },
  { key: 'LAST_30', label: '30 dias', days: 30 },
  { key: 'LAST_90', label: '90 dias', days: 90 },
];

const RangeDatePicker = ({
  startDate,
  endDate,
  onChangeStartDate,
  onChangeEndDate,
  customPeriods,
}) => {
  const [periodDate, setPeriodDate] = useState(null);

  const activePeriods = customPeriods || DEFAULT_PERIODS;

  const onChangePeriodDate = (selectedPeriod) => {
    const today = new Date();
    setPeriodDate(selectedPeriod.key);

    const endStr = format(today, 'yyyy-MM-dd');
    onChangeEndDate(endStr);

    const start = subDays(today, selectedPeriod.days);
    onChangeStartDate(format(start, 'yyyy-MM-dd'));
  };

  return (
    <DateContainer>
      <PeriodContent>
        {activePeriods.map((period) => (
          <StyledChip
            key={period.key}
            clickable
            onClick={() => onChangePeriodDate(period)}
            color={periodDate === period.key ? 'secondary' : 'primary'}
            label={period.label}
          />
        ))}
      </PeriodContent>

      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <DateContent>
          <DatePicker
            label="Início"
            value={startDate ? parseISO(startDate) : null} 
            onChange={(newValue) => {
              if (isValid(newValue)) {
                setPeriodDate(null);
                onChangeStartDate(format(newValue, 'yyyy-MM-dd'));
              }
            }}
            renderInput={(params) => <TextFieldStyled size="small" {...params} />}
            inputFormat="dd/MM/yyyy"
          />
          
          <ToStyled>a</ToStyled>

          <DatePicker
            label="Fim"
            value={endDate ? parseISO(endDate) : null}
            onChange={(newValue) => {
              if (isValid(newValue)) {
                setPeriodDate(null);
                onChangeEndDate(format(newValue, 'yyyy-MM-dd'));
              }
            }}
            renderInput={(params) => <TextFieldStyled size="small" {...params} />}
            inputFormat="dd/MM/yyyy"
          />
        </DateContent>
      </LocalizationProvider>
    </DateContainer>
  );
};

export default RangeDatePicker;